import { TranslateService } from '@ngx-translate/core';
import { formatDate } from '@angular/common';

import { language } from '~/core/constants/constants';

export class DateUtils {
  static isToday(date: Date): boolean {
    const now = new Date();
    return (
      date.getUTCDate() === now.getUTCDate() && date.getUTCMonth() === now.getUTCMonth() && date.getUTCFullYear() === now.getUTCFullYear()
    );
  }

  static dateFormatter(translate: TranslateService, date) {
    if (date === '') {
      return '';
    }
    return formatDate(new Date(date), this.dateFormat(translate), language.PT_BR);
  }

  static dateFormat(translate: TranslateService) {
    if (translate.currentLang === language.PT_BR) {
      return 'dd/MM/yyyy';
    }
    return 'MM/dd/yyyy';
  }
}
